export default "{\n    \"label\": \"Dispute Status\",\n    \"options\": {\n        \"true\": \"Disputed\",\n        \"false\": \"Not Disputed\"\n    }\n}\n"